import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

Vue.config.productionTip = false
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
//@ts-ignore
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate)
// all modules
//@ts-ignore
import Notiflix from "notiflix";
Vue.use(Notiflix);
//@ts-ignore
import MoneySpinner from 'v-money-spinner'
Vue.use(MoneySpinner)
import VueFriendlyIframe from 'vue-friendly-iframe';

Vue.use(VueFriendlyIframe);
new Vue({
  router,
  store,
  //@ts-ignore
  render: h => h(App)
}).$mount('#app')
